module.exports = __webpack_public_path__ + "img/cloud_analytics.0b96d7ac.png";